module.exports = __webpack_public_path__ + "static/media/salvini.ec00e623.png";